module.exports = __webpack_public_path__ + "img/3.33196e1a.svg";